export default "__VITE_ASSET__BFl$Jqmk__"